var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ViewForm", {
    attrs: { "set-flag": _vm.GOODS_COMBO_TYPES.PACKAGE, "is-audit": "" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }